<template>
    <div class="LoginPage_wrap">
        <div class="LoginPage_login">
            <AppConfirmDialog v-model="showConfirmationDialog" :title="confirmationTitle"
            :message="confirmationMessage" @confirm="handleConfirm" />
            <div class="LoginPage_login__box_in">
                <!-- 제14회 플랫폼 이미지에 제목과 로고가 포함되어 기존 오버레이를 임시 비활성화합니다.
                <div class="LoginPage_login__img--title">
                    <h1><b>제 10회 A to Z</b> 연수강좌</h1>
                    <h2><b>A</b>therosclearosis to <b>Z</b>ero</h2>
                </div>
                <div class="LoginPage_login__form--logo">
                    <img src="~@/assets/images/logo_white.png"/>
                    <h2>교육위원회</h2>
                </div>
                -->
            </div>
            <div class="LoginPage_login__form_wrap">
                <div class="LoginPage_login__form">
                    <div class="LoginPage_login__form--input">
                        <div class="LoginPage_login__form--title">
                            <h1>로그인</h1>
                            <span>사전등록하신 이름과 비밀번호 뒷자리를 입력해주세요.</span>
                        </div>
                        <div class="LoginPage_login__form--input_email">
                            <label for="name">이름</label>
                            <input v-model="name"  class="input_custom" placeholder="이름" @blur="validateName"  @keyup.enter="submitLogin"/>
                            <div class="input_custom__stste">
                                <div v-if="nameError" class="input_custom__error">
                                    <v-icon class="mdi mdi-alert-circle-outline" x-small color="#ED2727" />
                                    <span class="input_custom__error_txt">{{ nameError }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="LoginPage_login__form--input_password">
                            <label for="password">비밀번호</label>
                            <input v-model="password" type="password" class="input_custom" placeholder="휴대폰번호 뒤 4자리" @blur="validatePassword"  @keyup.enter="submitLogin"/>
                            <div class="input_custom__stste">
                                <div v-if="passwordError" class="input_custom__error">
                                    <v-icon class="mdi mdi-alert-circle-outline" x-small color="#ED2727" />
                                    <span class="input_custom__error_txt">{{ passwordError }}</span>
                                </div>
                            </div>
                            </div>
                        <v-btn :loading="loading" @click="submitLogin()" class="LoginPage_login__form--input_btn" block elevation="0" x-large>
                            로그인
                        </v-btn>
                    </div>
                </div>
            </div>
        </div>
        <div class="LoginPage_login__form--logo-mo">
            <img src="~@/assets/images/logo_default.png"/>
            <h2>교육위원회</h2>
        </div>
    </div>
</template>


<script>
import { mapActions } from 'vuex';
import AppConfirmDialog from '@/components/app/AppConfirmDialog.vue';
// import PlayerApi from '@/api/player/PlayerApi';

export default {
    components: {
        AppConfirmDialog
    },
    data() {
        return {
            name: null,
            password: null,
            confirmationMessage: null,
            confirmationTitle: null,
            showConfirmationDialog: false,
            passwordError: null,
            nameError: null,
            loading: false,
        }
    },
    methods: {
        ...mapActions('user', ['login']),
        submitLogin(){
            this.validatePassword();
            if (!this.nameError && !this.passwordError) {
                this.loading = true;
                this.login({name: this.name, password: this.password})
                    .then(() => {
                        // this.$router.push({ path: '/courselive' });

                        // await PlayerApi.playStart();

                        if (this.$route.path !== '/programlist') {
                            this.$router.push('/programlist').catch(err => {
                                if (err.name !== 'NavigationDuplicated') throw err;
                            });
                        }
                    })
                    .catch(error => {
                        this.showConfirmationDialog = true;
                        this.confirmationTitle = "로그인 실패";
                        this.confirmationMessage = error.response && error.response.data.message
                            ? error.response.data.message
                            : "로그인 과정에서 오류가 발생했습니다. 다시 시도해 주세요.";
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        handleConfirm() {
            this.showConfirmationDialog = false;
            this.name = '';
            this.password = '';
        },
        validateName() {
            if (!this.name) {
                this.nameError = "이름을 입력해주세요.";
            } else {
                this.nameError = "";
            }
        },
        validatePassword() {
            if (!this.password) {
                this.passwordError = "비밀번호를 입력해주세요.";
            } else if (this.password.length !== 4 || isNaN(this.password)) {
                this.passwordError = "비밀번호는 4자리 숫자로 입력해주세요.";
            } else {
                this.passwordError = "";
            }
        },
    }
}
</script>
